import React from 'react';
import { Clapperboard, FileText, Sparkles } from 'lucide-react';

export const PLATFORM_OPTIONS = [
  {
    value: 'instagram',
    label: 'Instagram',
    icon: (
      <img
        src="/icons/instagram-logos/GradientGlyph/Instagram_Glyph_Gradient.png"
        alt="Instagram"
        className="w-4 h-4 object-contain"
      />
    ),
  },
];

export const CONTENT_TYPE_OPTIONS = [
  {
    value: 'reel',
    label: 'Reel',
    icon: <Clapperboard className="w-4 h-4 text-[#F43F5E]" />,
  },
  {
    value: 'story',
    label: 'Story',
    icon: <Sparkles className="w-4 h-4 text-[#A655F8]" />,
  },
  {
    value: 'post',
    label: 'Post',
    icon: <FileText className="w-4 h-4 text-[#0EA5E9]" />,
  },
];
